/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Card } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import "./HomeFeatures.scss";
import "./HomeFeatures.scss";

function HomeFeatures() {

  const upgradeImageRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const handleScrollAnimation = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleScrollAnimation, {
      threshold: 0.1,
    });

    if (upgradeImageRef.current) {
      observer.observe(upgradeImageRef.current);
    }

    cardRefs.current.forEach((card) => {
      if (card) {
        observer.observe(card);
      }
    });

    return () => {
      if (upgradeImageRef.current) {
        observer.unobserve(upgradeImageRef.current);
      }
      cardRefs.current.forEach((card) => {
        if (card) {
          observer.unobserve(card);
        }
      });
    };
  }, []);
  return (
    <div>

      {/* Main content */}
      <Container fluid className="home-features-section">
        <Container>
          <Row className="align-items-center justify-content-center features-title">
            <Col md={6}>
              <div className="video-container">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/SStR0vhThTA?start=7&autoplay=1&mute=1&loop=1&playlist=SStR0vhThTA"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>

            <Col md={6} className="video-text">
              <h2>
                <span className="extra">We're Leading the Way</span> in Product Sourcing, Development, and
                Manufacturing
              </h2>
              <p>
                Looking to outsource production overseas without compromising on
                cost or quality? Or are you an innovator ready to turn your
                vision into reality?
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center left">
            <Col md={4} className="mb-4 equal-height-cards">
              <Card className="slide-up red-wireframe">
                <h4>Development</h4>
                <div className="flex alignCenter">
                  <p>
                    We specialize in product development, outsourcing, and
                    manufacturing with a streamlined, factory-direct process
                    that prioritizes quality every step of the way.
                  </p>
                </div>
              </Card>
            </Col>

            <Col md={4} className="mb-4 equal-height-cards">
              <Card className="slide-up red-wireframe">
                <h4>Expertise</h4>
                <div className="flex alignCenter">
                  <p>
                    With offices worldwide, we leverage our extensive resources
                    to provide high-quality products and exceptional service
                    tailored to your needs.
                  </p>
                </div>
              </Card>
            </Col>

            <Col md={4} className="mb-4 equal-height-cards">
              <Card className="slide-up red-wireframe">
                <h4>Global Reach</h4>
                <div className="flex alignCenter">
                  <p>
                    Our diverse team has in-depth knowledge of the Asia-Pacific
                    market, allowing us to deliver optimal manufacturing
                    solutions through our extensive partner network.
                  </p>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Thin sliding carousel */}
      <div className="text-carousel-wrapper">
        <div className="text-carousel">
          <div className="carousel-text">Global sourcing solutions</div>
          <div className="carousel-text">Product development experts</div>
          <div className="carousel-text">Factory-direct approach</div>
          <div className="carousel-text">Supply chain optimization</div>
          <div className="carousel-text">Cost-effective manufacturing</div>
          <div className="carousel-text">High-quality production</div>
          <div className="carousel-text">Seamless outsourcing</div>
          <div className="carousel-text">Asia-Pacific specialists</div>
          <div className="carousel-text">Reliable partnership</div>
          <div className="carousel-text">Streamlined processes</div>
          <div className="carousel-text">Custom manufacturing solutions</div>
          <div className="carousel-text">Diverse industry expertise</div>
          <div className="carousel-text">Transparent communication</div>
          <div className="carousel-text">On-time delivery</div>
          <div className="carousel-text">Strategic partnerships</div>
          <div className="carousel-text">Tailored product sourcing</div>
          <div className="carousel-text">End-to-end supply chain support</div>
          <div className="carousel-text">Quality assurance focus</div>
          <div className="carousel-text">Manufacturing innovation</div>
          <div className="carousel-text">Scalable solutions</div>
        </div>
      </div>
    </div>
  );
}

export default HomeFeatures;
